import { useAppSelector } from '../../../../../../store/hooks';
import { getFirmwareFileIdSelector } from '../../../../store/selectors/get-firmware-file-id/get-firmware-file-id.selector';
import { getFirmwareFileSelector } from '../../../../store/selectors/get-firmware-file/get-firmware-file.selector';
import { FirmwareFileSelectorsModel } from './models/firmware-file-selectors.model';

export const useGetFirmwareFileSelectors = (): FirmwareFileSelectorsModel => {
  const firmwareFileId = useAppSelector(getFirmwareFileIdSelector);
  const firmwareFile = useAppSelector(getFirmwareFileSelector);
  return {
    firmwareFileId,
    firmwareFile,
  };
};
